"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
function TransparentCover(props) {
    var style = {
        display: props.active ? "block" : "none",
        position: "absolute",
        zIndex: props.zIndex !== undefined ? props.zIndex : 20,
        top: 0, left: 0, right: 0, bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0)"
    };
    return React.createElement("div", { style: style, onClick: props.onClick });
}
exports.TransparentCover = TransparentCover;
